<div class="stripe_1"></div>

<div id="header">
    <div id="header_logo">
        <a routerLink="/" title="Hosting">
            <img src="assets/images/rackeo/marca/logo.svg" alt="Rackeo - Hosting, VPS y Servidores Dedicados" />
        </a>
    </div>

    <div id="header_menu">
        <div class="moduletable">
            <ul class="menu">
                <li class="item33">
                    <a [href]="URL.RACKEO_LOGIN">
                        <img src="assets/images/rackeo/cabecera/ic-area-cliente.png" class="header-menu__icon"
                            alt="Ingresar al área de cliente" />
                        <span>Ingresar Area Cliente</span>
                    </a>
                </li>
                <li class="item31" *ngIf="site.isChile">
                    <a routerLink="/paga-deuda">
                        <img src="assets/images/rackeo/cabecera/ic-pago-cuentas.png" class="header-menu__icon"
                            alt="Pago de cuentas Rackeo" />
                        <span>Pago de cuentas</span>
                    </a>
                </li>
            </ul>
        </div>
        <div class="moduletable user_country">
            <mat-form-field appearance="outline" class="header-select-field header-country__field" floatLabel="never">
                <mat-select
                    [value]="site.countryCode"
                    placeholder="País"
                    (selectionChange)="onCountrySelection($event.value)"
                    panelClass="header-select-panel"
                    disableOptionCentering>
                    <mat-select-trigger>País</mat-select-trigger>
                    <mat-option *ngFor="let c of countries" [value]="c.code">
                        <span class="header-country__option">
                            <img [src]="c.flag" [alt]="'Bandera de ' + c.label" class="header-select__flag" />
                            <span>{{ c.label }} ({{ c.symbol }})</span>
                        </span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="header-help" *ngIf="contact$ | async as contact">
            <mat-form-field appearance="outline" class="header-select-field header-help__field" floatLabel="never">
                <mat-select
                    [value]="helpSelection"
                    placeholder="Ayuda"
                    (selectionChange)="onHelpSelection($event.value, contact)"
                    panelClass="header-select-panel header-help-panel"
                    disableOptionCentering>
                    <mat-select-trigger>Ayuda</mat-select-trigger>

                    <mat-option [value]="helpSelectEmptyValue" class="help-null-option" aria-hidden="true"></mat-option>

                    <mat-option value="phone">
                        <span class="header-help__option">
                            <span class="header-help__option-icon header-help__option-icon--phone" aria-hidden="true">
                                <svg-icon-sprite [src]="'icon-phone'" width="11" height="11"></svg-icon-sprite>
                            </span>
                            <span>Atención al cliente</span>
                        </span>
                    </mat-option>

                    <mat-option value="portal">
                        <span class="header-help__option">
                            <span class="header-help__option-icon header-help__option-icon--portal" aria-hidden="true">
                                <svg-icon-sprite [src]="'icon-portal'" width="11" height="11"></svg-icon-sprite>
                            </span>
                            <span>{{ contact.chatLabel }}</span>
                        </span>
                    </mat-option>

                    <mat-option value="chat">
                        <span class="header-help__option">
                            <span class="header-help__option-icon header-help__option-icon--chat" aria-hidden="true">
                                <svg-icon-sprite [src]="'icon-chat'" width="11" height="11"></svg-icon-sprite>
                            </span>
                            <span>Chat en línea</span>
                        </span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
</div>
